import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import Logo from "@/components/site/Logo";

const links = [
  { href: "/qui-sommes-nous", label: "À propos" },
  { href: "/#services", label: "Services" },
  { href: "/#pourquoi", label: "Pourquoi nous" },
  { href: "/#process", label: "Process" },
  { href: "/#preuves", label: "Crédibilité" },
  { href: "/ressources", label: "Ressources" },
  { href: "/#faq", label: "FAQ" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/90 backdrop-blur-md border-b border-border"
          : "bg-transparent"
      }`}
    >
      <div className="container-wide flex h-28 items-center justify-between">
        <a
          href="#top"
          data-testid="brand-logo"
          className="group"
        >
          <Logo withTagline variant="dark" />
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="underline-link text-[13px] font-medium text-primary/85 hover:text-[hsl(var(--brand-terra))]"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a
            href="/#contact"
            data-testid="nav-cta-devis"
            className="btn-primary text-xs"
          >
            Demander mon devis
          </a>
        </div>

        <button
          aria-label="Menu"
          data-testid="mobile-menu-button"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden inline-flex h-10 w-10 items-center justify-center border border-border text-primary"
        >
          {open ? <X size={18} /> : <Menu size={18} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden border-t border-border bg-white"
        >
          <div className="container-wide flex flex-col gap-4 py-6">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-base text-primary"
              >
                {l.label}
              </a>
            ))}
            <a
              href="/#contact"
              onClick={() => setOpen(false)}
              className="btn-primary justify-center mt-2"
            >
              Demander mon devis
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
